<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 40px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('el_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('el_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/illust-company-section-about.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-sidenav :selectedItem="selectedItem"></app-sidenav>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('engineer_list')}}</span>
            </div>

            <div class="row companyview-topoptions">
              <div class="col-md-4">
                <div class="selectdiv peselectboxs form-group" style="min-width: 330px;">
                  <select class="form-control" v-model="sortEngineer" @change="sortingEngineer(page)">
                    <!-- <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="">{{$t('el_select')}}</option> -->
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="New User">{{$t('el_new_user')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="Old User">{{$t('el_old_user')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="Higher Total Score">{{$t('el_higher_total_score')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="Higher Technology Score">{{$t('el_higher_technology_score')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="Higher Management Score">{{$t('el_higher_management_score')}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="e_engineers != ''">
              <div class="row companyviews" v-for="(engineer,index) of e_engineers" :key="index">
                <div class="col-md-12 ceboxes">
                  <div id="pointer" v-if="newEngineer(engineer)">
                    <span class="newtag cocogothic spacing1-2">NEW</span>
                  </div>

                  <div class="row">
                    <div class="col-md-4" style="text-align: center;">
                        <div class="imgpanel mb-3">
                          <video v-if="engineer.video"   height="150" width="150" controls autoplay loop>
                            <source :src="engineer.video">
                          </video>
                          <img v-if="engineer.image" class="c_images" :src="engineer.image" />
                        </div>
                      <p v-if="engineer.initials" class="pgraytxt mplus2p-m spacing1-2 noiseblack mt-1 mb-1">{{ engineer.initials}}</p>
                      <p v-if="engineer.job_seeking_situation" class="link  mplus2p-m spacing1-2  mb-3">{{lan == "en" ? engineer.job_seeking_situation.en_situation :engineer.job_seeking_situation.jp_situation}}</p>
                      <!-- <div class="" v-if="engineer.total_score > 0">
                        <div class="row score-color">
                          <div class="col-md-5   text-center" style="align-self: center;">
                            <p class="cocogothic spacing3-2  spacing3-2 noiseblack statustitle " style="align-self: center;">
                              {{$t('sk_total_lb')}}</p>
                            <div >
                              <h4 class="mplus2p-r noiseblack " id="total">{{engineer.total_score}}</h4>
                            </div>
                          </div>
                          <div class="col-md-7 text-center" style="border-left: 2px solid #a1a1a1;">
                            <div class="row">
                              <div class="col-md-12" style="border-bottom: 2px solid #a1a1a1">
                                  <p class="cocogothic spacing3-2 noiseblack statustitle text-center">{{$t('sk_technical_lb')}}</p>
                                  <div class=" mb-0">
                                    <h4 class="mplus2p-r noiseblack" id="technical">{{engineer.technical_score}}</h4>
                                  </div>
                              </div>
                            </div>
                             <div class="row">
                              <div class="col-md-12">
                                  <p class="cocogothic text-center spacing3-2 noiseblack statustitle">{{$t('sk_management_lb')}}/<br>{{$t('sk_business_lb')}}</p>
                                  <div class="mt-3">
                                    <h4 class="mplus2p-r noiseblack " id="management">{{engineer.other_score}}</h4>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <div class="col-md-8 mb-2" style="text-align: left;">
                      <div class="row">
                        <div class="col-md-12 mb-2">
                           <button class="btn clickcbtn whitebtn"  @click="engineerDetails(engineer.id)">
                                <span class="cstitle mplus2p-m spacing1-2">
                                  <span class="cplus">+</span>&nbsp;{{$t('c_andmore')}}</span>
                              </button>
                          <span v-if="!testUser">
                            <button v-if="engineer.pivot" class="btn whitebtn clickcbtn like" @click="onFavClick(engineer.id,index)" style="margin-right: 10px;">
                              <i class="fa fa-heart margin-r-5"></i>
                            </button>

                            <button v-if="!engineer.pivot" class="btn whitebtn clickcbtn" @click="onFavClick(engineer.id,index)" style="margin-right: 10px;">
                              <i class="fa fa-heart margin-r-5"></i>
                            </button>
                            <button v-if="engineer.verified != 0" class="btn whitebtn clickcbtn"  @click="sandMsg(engineer.id)" style="margin-right: 10px;">
                              <i class="fa fa-envelope margin-r-5"></i>
                            </button> <div v-if="engineer.want_to_talk_casually" class="casually">{{$t('speech_bubble')}}</div>
                          </span>
                        </div>
                      </div>
                       <div class="row">
                        <div class="col-md-12">
                            <div v-if="engineer.last_login_time" class="float-right">
                                 {{$t('last_login_time')}} : {{dateFormate(engineer.last_login_time)}}
                            </div>
                        </div>
                       </div>
                      <div class="mt-1">
                        <table class="table mb-1" >
                            <tbody>
                              <tr v-if="engineer.expertise">
                                <th width="30%" class="table-primary cocogothic2" scope="row">{{$t('expertise')}}</th>
                                <td><span class="p-size ml-2">{{lan == 'en' ? engineer.expertise.en_expertise : engineer.expertise.jp_expertise}}</span></td>
                              </tr>
                              <tr v-if="engineer.required_positions.length > 0">
                                <th width="30%" class="table-primary cocogothic2" scope="row">{{$t('ep_required_position')}}</th>
                                <td>
                                    <span v-for="(item, index) in engineer.required_positions" :key="index" class="layer2">
                                      {{lan == 'en' ? item.en_required_position : item.jp_required_position}}
                                    </span>
                                </td>
                              </tr>
                              <tr v-if="engineer.required_contracts.length > 0">
                                <th width="30%" class="table-primary cocogothic2" scope="row">{{$t('ep_requried_type_of_contract')}}</th>
                                <td>
                                  <span v-for="(item, index) in engineer.required_contracts" :key="index" class="layer2">
                                    {{lan == 'en' ? item.en_required_type : item.jp_required_type}}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="engineer.engineer_past_experiences.length > 0">
                                <th width="30%" class="table-primary cocogothic2" scope="row">{{$t('ep_past_job_details')}}</th>
                                <td>
                                  <div v-for="(item, index) in engineer.engineer_past_experiences.slice(0,1)" :key="index">
                                    <div class="jobDetail ml-2">
                                        <p  style="text-transform: capitalize" class="pgraytxt jobDetail mplus2p-m spacing1-2 noiseblack mt-1 mb-1  ">{{item.position_overview}}</p>
                                        <p  class="pgraytxt mplus2p-m spacing1-2 noiseblack mt-1 mb-1  jobDetail jobDetailDesc">{{item.responsibility}}</p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                  </div>
                   <div class="row text-left" >
                        <div class="col-md-12">
                          <div v-if="engineer.manager_comments" class="comment-block">
                            <p class="comment-title">{{$t('comments_manager')}}</p>
                            <p class="comment-desc">{{engineer.manager_comments}}</p>
                        </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row companyviews">
                <div class="col-md-12 ceboxes">
                  <div class="alert alert-danger">
                    <strong>{{$t('err_engineer')}}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="e_engineers != '' && totalPage != 1" style="margin-right: -30px;" class="pagination justify-content-end mt-2">
              <vue-pagination :total="totalPage" v-model="page" @input="nextPage"></vue-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hashids from "hashids";
import axios from "axios";
import e_sidenav from "./search_company_sidebar";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      engineerSortData: '',
      engineerFilterData: '',
      engineerSearchData: '',
      id: 0,
      sortEngineer: "New User",
      filterEngineer: 0,
      title: "",
      companyUserId: "",
      selectedItem: 51,
      loading: false,
      company_id: "",

      page: 1,
      totalPage: 1,

      e_engineers: [],
      e_engineer_favorite: [],

      isFavorite: false,
      likeLoader: false,

      window_width: "",

      totalD: {},
      technicalD: {},
      managementD: {},
      businessD: {},

      model: {},

      lan: "jp",
      applyFilterDebounce: {},
      searchFilterDebounce: {},
      testUser: 0
    };
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    var retrievedData = localStorage.getItem("user");
    var data = JSON.parse(retrievedData);
    this.companyUserId = data.id;
     this.testUser = data.test_user;
    this.company_id = this.$route.params.cid;
    this.window_width = $(window).width() + 17; //default
    this.showorhide();

    this.model.total = 100;
    this.model.technical = 60;
    this.model.management = 26;
    this.model.business = 100;
    this.doCenter();
    this.getEngineerList(this.$route.query.page);
    this.$on("applyFilter", data => {
      if (this.applyFilterDebounce) clearTimeout(this.applyFilterDebounce);
      this.applyFilterDebounce = setTimeout(() => {
        this.engineerFilterData = data;
        this.sortingEngineer(1);
      }, 300);
    });
    this.$on("searchFilter", data => {
      if (this.searchFilterDebounce) clearTimeout(this.searchFilterDebounce);
      this.searchFilterDebounce = setTimeout(() => {
        this.engineerSearchData = data;
        this.sortingEngineer(1);
      }, 300);
    });
  },
  watch: {
    $route(to, from) {
      if(this.filterEngineer ==1){
        this.sortingEngineer(this.page );
      }
      if(this.filterEngineer ==0){
        this.getEngineerList(this.$route.query.page);
      }
    }
  },
  components: {
    appSidenav: e_sidenav
  },
  computed: {
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();

      this.doCenter();
      this.getEngineerList(this.page);
    }
  },
  methods: {
    dateFormate(date){
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    newEngineer(data){
      return moment().diff(moment(data.created_at),'days') < 30 ?  true :  false;
    },
    engineerDetails(eid){
       var hashids = new Hashids(
        "EngineerIds",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
     let routeData =  this.$router.resolve({
            name: "companyEngineerDetail",
            params: { uid: hashids.encode(eid)},
          });
      window.open(routeData.href, '_blank');
    },
    sandMsg(eid) {
      var hashids = new Hashids(
        "this is my salt",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      this.$router.push("/global/chatroom/" + hashids.encode(eid));
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $(".total").css("font-size", "1.2rem");
        $(".technical").css("font-size", "1.2rem");
        $(".management").css("font-size", "1.2rem");
        $(".business").css("font-size", "1.2rem");
        txtwidth = [12.53, 25.05, 37.56];
        txtheight = 4;
      } else {
        $(".total").css("font-size", "1.2rem");
        $(".technical").css("font-size", "1.2rem");
        $(".management").css("font-size", "1.2rem");
        $(".business").css("font-size", "1.2rem");
        txtwidth = [12.53, 25.05, 37.56];
        txtheight = 4;
      }

      const ttrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const ttrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.total.toString().length - 1]) /
        2;
      $(".total").css("margin-top", ttrighttop.toString() + "px");
      $(".total").css("margin-left", ttrightright.toString() + "px");

      const thrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const thrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.technical.toString().length - 1]) /
        2;
      $(".technical").css("margin-top", thrighttop.toString() + "px");
      $(".technical").css("margin-left", thrightright.toString() + "px");

      const mgrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const mgrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.management.toString().length - 1]) /
        2;
      $(".management").css("margin-top", mgrighttop.toString() + "px");
      $(".management").css("margin-left", mgrightright.toString() + "px");

      const birighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const birightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.business.toString().length - 1]) /
        2;
      $(".business").css("margin-top", birighttop.toString() + "px");
      $(".business").css("margin-left", birightright.toString() + "px");
    },

    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },

    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },

    onFavClick(id, index, group, type = "") {
      let user = localStorage.getItem("user");
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        user_id: id
      };
      this.e_engineers[index].pivot = !this.e_engineers[index].pivot;
      this.$forceUpdate();
      axios
        .post("/favorite/engineer?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.e_engineers[index].pivot = !this.e_engineers[index].pivot;
            this.$forceUpdate();
          } else {
            if (res.data.liked) {
              this.$toaster.success(vm.$t("success_engineer_favorited"));
            } else {
              this.$toaster.error(vm.$t("err_engineer_favorited"));
            }
          }
        });
    },

    filterFavoriter() {
      for (var emp of this.e_engineers) {
        var index = this.e_engineer_favorite.findIndex(obj => {
          if (obj.pivot.user_id == emp.id) {
            return true;
          }
        });
        if (index != -1) {
          emp.pivot = true;
        } else {
          emp.pivot = false;
        }
      }
      this.$forceUpdate();
    },

    getFavoriter() {
      var token = localStorage.getItem("token");

      axios
        .get("/favorited/engineer?token=" + token)
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
          } else {
            var index = 1;
            for (var i = 0; i < res.data.data.data.length; i++) {
              this.e_engineer_favorite = res.data.data.data;
            }
            index++;
            this.filterFavoriter();
          }
        })
        .catch(error => console.log(error));
    },
    nextPage(page) {
      if (this.totalPage < this.page) return;
      if(this.filterEngineer ==1){
        this.sortingEngineer(page);
      }
      if(this.filterEngineer ==0){
        this.getEngineerList(page);
      }
    },
    getEngineerList(page) {
      this.filterEngineer = 0;
      if (page > 1) {
        page = page;
      }
      if (page < 1) {
        page = this.$route.query.page;
      }
      this.loading = true;
      axios
        .get("/engineer-list?page=" + page, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            this.loading = false;
            for (let index = 0; index < res.data.data.data.length; index++) {
              if (res.data.data.data[index].image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                res.data.data.data[index].video = res.data.data.data[index].image
                res.data.data.data[index].image = ""
              }else{
                res.data.data.data[index].image = res.data.data.data[index].image
              }
            }
            this.e_engineers = res.data.data.data;
            this.totalPage = res.data.data.last_page;
            this.cPage(res.data.data.current_page);
            this.page = res.data.data.current_page;
            this.getFavoriter();
          }
        })
        .catch(error => console.log(error));
    },
    cPage(currentPage) {
      this.$router.push({ query: { page: currentPage } });
    },
    sortingEngineer(page) {
      this.filterEngineer = 1;
      this.loading = true;

      var token = localStorage.getItem("token");
      let temp = this.engineerFilterData;
      if(!temp){
        temp = {}
      }
      temp["sort"]= this.sortEngineer;
      temp['item_id'] = this.engineerSearchData;

      axios
        .post("/filter-engineer-users?page="+page + "&token=" + token,temp)
        .then(res => {
          if (!res.data.success) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            this.loading = false;
             for (let index = 0; index < res.data.users.data.length; index++) {
              if (res.data.users.data[index].image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                res.data.users.data[index].video = res.data.users.data[index].image
                res.data.users.data[index].image = ""
              }else{
                res.data.users.data[index].image = res.data.users.data[index].image
              }
            }
            this.e_engineers = res.data.users.data;
            this.totalPage = res.data.users.last_page;
            this.cPage(res.data.users.current_page);
            this.page = res.data.users.current_page;
            this.getFavoriter();
          }
        });
    }
  }
};
</script>

<style scoped>
.casually{
  background: #3f7ed8;
  color: white;
  padding: 10px;
  border-radius: 6px;
  float: right;
  margin-right: 15px
}
.casually::after{
    content: '';
    position: absolute;
    right: 247px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left-color: #3f7ed8;

}
.p-size{
  font-size: 0.8125rem;
}
.jobDetailDesc{
  white-space:pre-wrap;
  text-align: justify;

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
   text-overflow: ellipsis;
   word-wrap: break-word;
  display: -webkit-box;

}
.table td, .table th {
    padding: 0.50rem;
    border: 1px solid #dee2e6;
}
.jobDetail{
  text-align: justify;
  font-size: 0.8125rem !important;
}
.comment-block{
  border: 2px solid #3f7ed8;
  padding: 20px;
  border-radius: 20px;
  margin-top: 15px !important;
}
.comment-title{
  color: #3f7ed8;
  font-size: 0.8125rem;
  text-decoration: underline;
  margin-bottom: 5px;
}
.comment-desc{
  white-space: pre-line;
  word-break: break-all;
  font-size: 0.8125rem;
  margin: 0;
  color: #3f7ed8;
}
.score-color{
  background-color: #e4e4e4;
  margin-left: 0px;
}
.link{
  font-size: 0.8125rem !important;
  color: #3f7ed8;
}
.loading .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
  font-size: 3em;
}
a:hover {
  text-decoration: none;
}

.score {
  color: #3f7ed8;
}

.layer {
  border: 2px solid #3f7ed8;
  font-size:  0.8125rem;
  font-weight: 700;
  font-style: normal;
  font-stretch: narrower;
  letter-spacing: 1.4px;
  color: #3f7ed8;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
  display: block;
  border-radius: 10px;
}

.layer2 {
  border: 2px solid #3f7ed8;
  font-size: 0.8125rem;
  font-weight: 400;
  font-style: normal;
  font-stretch: extra-condensed;
  letter-spacing: 0.4px;
  color: #3f7ed8;
  padding: 5px;
  margin-right: 5px;
  display: inline-block;
  border-radius: 11px;
  margin-bottom: 5px;
}

.layer3 {
  border: 2px solid #e69a9a;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  font-stretch: narrower;
  letter-spacing: 1.4px;
  color: #a15454;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 10px;
  /* white-space: pre;
    word-break: keep-all; */
  display: inline-block;
}

.fa-light {
  color: #666 !important;
}

.like .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
}
.cocogothic {
  height: 30px;
}
.cocogothic2 {
  font-weight: 400;
}
.table-primary{
  font-size: 0.8125rem;
  background-color: rgba(61, 125, 216, 0.16);
  color: #3c5064;
}
.pman {
  width: 80%;
  margin-top: 40px;
}

.companyad {
  width: 100%;
}
.top_summary_header {
  font-size: 2.2rem;
  font-weight: 500;
  margin-bottom: 11px;
}
.leftad {
  padding: 70px 20px;
}

.rightad {
  text-align: center;
  padding: 30px 0px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
}

.eview {
  padding: 30px 15px;
}

.statustitle {
  font-size: 0.8125rem;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 0px;
}

.statusnum {
  position: absolute;
  /*right: 46%;
          top: 55%;*/
  font-weight: bold;
  font-size: 2rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}
.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 0;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.ceboxes {
  margin: 16px;
  margin-top: 26px;
  margin-bottom: 0px;
  text-align: center;
}

#pointer {
  width: 59.7px;
  height: 24px;
  background: #3d7dd8;
  box-shadow: 0 1px 2px 0 rgba(60, 80, 100, 0.12);
  position: absolute;
  z-index: 1;
  left: 0;
  top: 15px;
}

#pointer:after {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 12px solid #3d7dd8;
  border-bottom: 12px solid transparent;
}

#pointer:before {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12px solid #3d7dd8;
  border-top: 12px solid transparent;
}

.newtag {
  font-size: 0.6875rem;
  font-weight: bold;
  color: white;
}

.c_images {
  border-radius: 100px;
  width: 150px;
  height: 150px;
  margin-top: 50px;
}

.imgpanel {
  text-align: center;
  margin: auto;
}
.imgpanel:hover{
  cursor: pointer;
}

.ctitlepanel {
  height: 50px;
}

.ctitle {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 10px;
}

.ctitlecomment {
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 5px;
}

.ccontents {
  font-size: 0.825rem;
}

.cline {
  margin-top: 0px;
  margin-bottom: 8px;
}

.cstitle {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}

.cplus {
  font-size: 1.5em;
  line-height: 1;
}

.skillsets {
  text-align: left;
  padding: 9px 10px;
}

.ron {
  width: 150px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 15px;
  width: 150px;
  height: 60px;
}



.business {
  margin-top: 60px;
  margin-left: 55px;
}


@media screen and (max-width: 992px) {
  .rightad {
    padding: 50px 0px;
  }
}

@media screen and (max-width: 768px) {
  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .rightad {
    padding: 0px 10px;
  }

  .leftad {
    padding: 20px 10px;
  }

  .rtoptions {
    margin-top: 14px;
    float: none;
    margin-left: 0px;
  }

  .skillsets {
    padding: 0;
    margin-top: 20px;
  }

  .ceboxes .col-md-3 {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 352px) {
  .ron {
    width: 100%;
  }
}
</style>
